import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Amplify } from 'aws-amplify';
import 'bootstrap-icons/font/bootstrap-icons.css';

if (process.env.REACT_APP_USER_POOL_ID === undefined) {
  throw new Error("REACT_APP_USER_POOL_ID is undefined");
}
if (process.env.REACT_APP_USER_POOL_CLIENT_ID === undefined) {
  throw new Error("REACT_APP_USER_POOL_CLIENT_ID is undefined");
}
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
    }
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
